import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    sintomas: [],
  },

  getters: {
    getSintomas: (state) => state.sintomas,
  },

  mutations: {
    SET_SINTOMAS(state, sintomas) {
      state.sintomas = sintomas;
    },
  },

  actions: {
    async fetchSintomas({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catSintomas')
        .then((response) => {
          commit('SET_SINTOMAS', response.data.data);
        });
    },
  },
};
